import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection, SolutionSection, DeliverablesSection } from '../components/ContentSection';
import { PricingCard } from '../components/PricingCard';
import { Footer } from '../components/Footer';
import { initPixel, trackPageView } from '../utils/pixel';
export function SalesPage() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-slate-900 text-slate-50 font-sans selection:bg-amber-500/30" data-id="element-168">
      <header className="absolute top-0 w-full z-50 py-6" data-id="element-169">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-170">
          <div className="font-bold text-xl tracking-tight text-white/90" data-id="element-171">
            NocheTran<span className="text-amber-500" data-id="element-172">quila</span>
          </div>
        </div>
      </header>

      <main data-id="element-173">
        <Hero data-id="element-174" />
        <ProblemSection data-id="element-175" />
        <SolutionSection data-id="element-176" />
        <DeliverablesSection data-id="element-177" />
        <PricingCard data-id="element-178" />
      </main>

      <Footer data-id="element-179" />

      {/* Botón flotante WhatsApp */}
      <a href="https://wa.me/17327620954?text=contactanos%21" target="_blank" rel="noopener noreferrer" className="fixed right-[18px] bottom-[18px] bg-[#25D366] text-white px-4 py-3 rounded-full font-bold text-sm shadow-[0_10px_25px_rgba(0,0,0,0.2)] z-[999999] hover:brightness-95 transition-all no-underline flex items-center gap-2" data-id="element-180">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-181">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-182" />
        </svg>
        Contáctanos
      </a>
    </div>;
}